<template>
    <div class="Login">
        <el-row class="logo-box">
            <el-col>
                <div>
                    <img src="http://tstatic.toptest.yidianzixun.com.ks3-cn-beijing.ksyun.com/public/files/logo1491900175336.png" alt="一点资讯">
                </div>
            </el-col>
        </el-row>
        <div class="login-content-box">
            <el-row class="project-name">
                <el-col>
                    <h3>一点资讯·营销平台</h3>
                </el-col>
            </el-row>
            <el-card class="box-card">
                <el-row>
                    <el-col>
                        <div class="grid-content bg-purple-dark">
                            <el-input :autofocus="true" v-model="accountEmail" placeholder="邮箱"></el-input>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <div class="grid-content bg-purple-dark">
                            <div class="grid-content bg-purple-dark">
                                <el-input v-model="password" :minlength="4" type="password" placeholder="密码"></el-input>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="login-btn-box">
                    <el-col>
                        <div class="grid-content bg-purple-dark">
                            <el-button class="login-btn" type="primary" @click="submit" @keyup.enter="submit">登录</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-card>
        </div>
    </div>
</template>
<script>
import CONFIG from '@/config/index.js';
import TOOL from '@/tool/index.js';
import router from '@/router/index.js';
import { mapActions } from 'vuex';
export default {
    name: 'Login',
    data() {
        return {
            accountEmail: null,
            password: null
        };
    },
    created() {
        let _this = this;
        document.onkeydown = (e) => {
            if (e.keyCode === 13) {
                _this.submit();
            };
        };
    },
    methods: {
        ...mapActions([
            'init'
        ]),
        submit: function () {
            let that = this;
            if (!that.accountEmail || that.accountEmail.indexOf('@yidian-inc.com') === -1 || !that.password) {
                that.$notify.error({
                    message: '用户名或密码错误'
                });
                return;
            };
            that.login(that.accountEmail, md5(that.password), function (userInfo) {
                if (userInfo) {
                    that.getPermission(userInfo.userId, userInfo.name, function (permissionInfo) {
                        if (permissionInfo) {
                            that.init({
                                userId: permissionInfo.userId,
                                accountEmail: permissionInfo.accountEmail,
                                userName: permissionInfo.userName,
                                permissionsId: permissionInfo.permissionsId,
                                permissionsName: permissionInfo.permissionsName
                            });
                            router.push({
                                name: 'Content',
                                params: {
                                    userId: Base64.encodeURI( permissionInfo.userId ),
                                    accountEmail: Base64.encodeURI(permissionInfo.accountEmail),
                                    version: '2.0.0'
                                }
                            });
                        }
                    });
                }
            });
        },
        login: function (accountEmail, password, callback) {
            this.$http.post(CONFIG.HOST + '/login/check', {
                name: accountEmail,
                pwd: password
            }).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    if (callback) {
                        callback(result.data);
                    } else {
                        console.error("【营销平台】登录callback为空");
                    }
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                };
            }, (response) => {
                console.log(response);
            });
        },
        getPermission: function (userId, accountEmail, callback) {
            this.$http.get(CONFIG.HOST + '/users/getUserById?userId=' + userId + '&accountEmail=' + accountEmail + '&t=' + TOOL.getCurrentTime()).then((response) => {
                let result = response.body;
                if (result && result.status === 1 && result.data.length > 0) {
                    if (callback) {
                        callback(result.data[0]);
                    } else {
                        console.error("【营销平台】获取用户权限callback为空");
                    }
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        }
    }
}
</script>
<style>
.Login {
    width: 100%;
    height: 100%;
    background: #1F2D3D;
    position: fixed;
    left: 0;
    top: 0;
}

.logo-box {
    width: 130px;
    position: absolute;
    left: 20px;
    top: 20px;
}

.logo-box img {
    width: 100%;
}

.login-content-box {
    width: 300px;
    margin: 0 auto;
    margin-top: 230px;
}

.project-name {
    color: #fff;
    text-align: center;
    width: 100%;
    margin-bottom: 20px;
}

.box-card {
    width: 100%;
}

.el-row {
    margin-bottom: 4px;
}

.el-col {
    border-radius: 4px;
}

.login-btn-box {
    margin-top: 20px;
}

.login-btn {
    width: 100%;
}
</style>




// WEBPACK FOOTER //
// Login.vue?79124004